// extracted by mini-css-extract-plugin
export var container = "index-module--container--IEqjw";
export var videoDescription = "index-module--videoDescription--Nyn4r";
export var videoPreview = "index-module--videoPreview--qjQtX";